import { createStore } from 'redux';
import RootReducer from '../reducers/RootReducer';
import { persistStore } from 'redux-persist';

const store = createStore(RootReducer);
const persistor = persistStore(store);

export { store, persistor };